<template>
  <div id="app">
    <nav-header v-if="isWhitePath"></nav-header>
    <router-view />
  </div>
</template>

<script>
import navHeader from "@/components/NavHeader";
export default {
  name: 'App',
  data() {
    return {
      //定义状态
      isRouterAlive: true
    };
  },
  watch: {
    // '$route' (to, from) {
    //
    // }
  },
  mounted(){

  },
  metaInfo: {
    meta: [
      { name: 'Title', content: '皇太后餐點管理系統', vmid: 'Title' },
      { name: 'Author', content: '皇太后餐點管理系統', vmid: 'Author' },
      { name: 'Subject', content: '皇太后餐點管理系統', vmid: 'Subject' },
      { name: 'Description', content: '皇太后餐點管理系統', vmid: 'Description' },
      { name: 'Keywords', content: '皇太后餐點管理系統', vmid: 'Keywords' },
      { property: 'og:image', content: '/favicon.ico', vmid: 'og:image' },
      { property: 'og:site_name', content: '皇太后餐點管理系統', vmid: 'og:site_name' },
      { property: 'og:description', content: '皇太后餐點管理系統', vmid: 'og:description' },
      { property: 'og:url', content: '#', vmid: 'og:url' },
      { property: 'og:title', content: '皇太后餐點管理系統', vmid: 'og:title' }
    ]
  },
  methods: {

  },
  components: {
    navHeader,
  },
  computed: {
    isWhitePath: {
      get() {
        let arr = ['/login','/Home','/']
        if (arr.includes(this.$route.path)) {
          return false
        } else {
          return true
        }
      }
    }
  },

}
</script>
<style lang="scss">
#app {
  //font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
